import { upperCase } from 'lodash';

import { createQueryFilters } from 'components/shared/AgTablePage/lib/createQueryFilters';

export default function formatFilters({
  filters,
  page,
  limit,
  sort,
  patientId,
  myPortalPractice,
  appointmentId,
  level
}) {
  const appliedFilters = createQueryFilters(filters);

  return {
    patientId: level !== 'practice' ? patientId : [], //filters?.patient_id.flatMap((patient) => patient.values),
    page,
    level,
    limit,
    sort: sort && { column: sort?.field, sortBy: upperCase(sort?.sort) },
    ...(myPortalPractice ? { myPortalPractice } : {}),
    ...(appointmentId ? { appointmentId } : {}),
    filters: appliedFilters
  };
}
